<div class="flex flex-col -m-6">

    <!-- Header -->
    <div
        class="flex flex-0 sticky -top-6 z-50 items-center justify-between h-16 pr-3 sm:pr-5 pl-6 sm:pl-8 bg-primary text-on-primary">
        <div class="text-lg font-medium">{{ 'goal.goalDateTitle' | transloco }}</div>
        <button mat-icon-button (click)="closeDialog()" [tabIndex]="-1">
            <mat-icon class="text-current" svgIcon="heroicons_outline:x"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <ng-container>
        <div class="flex flex-col p-6">
            <mat-form-field class="flex flex-col w-full items-center cursor-pointer">
                <mat-label>{{ 'goal.goalDateMessage' | transloco }}</mat-label>
                <input readonly matInput [formControl]="date" 
                    [min]="datemin"
                    [matDatepicker]="datepicker"
                    (click)="openDatepickerOnClick(datepicker)">
                <mat-datepicker-toggle matSuffix [for]="datepicker"></mat-datepicker-toggle>
                <mat-datepicker #datepicker [startView]="'month'"></mat-datepicker>
            </mat-form-field>
        </div>
    </ng-container>

    <!-- Actions -->
    <div class="flex flex-col sm:flex-row justify-end gap-2 px-4 pb-2 sm:px-8 sm:pb-8 w-full">
        <button (click)="closeDialog()" mat-stroked-button>
            {{ 'cancel' | transloco }}
        </button>
        <button (click)="save()" mat-flat-button color="primary">
            {{ 'accept' | transloco }}
        </button>
    </div>
</div>